import { SearchInput } from '../../ui-kit/SearchInput'
import { GRID_FORM_CONFIG_T } from '../../../common/FormGenerator'
import { SOCIAL_ORDER_FOCUS_OPTIONS } from '../../../consts/socialOrderFocus'
import { FocusCheckboxGroup } from '../../SocialOrder/FocusCheckboxGroup'

export type FiltrationBlockName = 'search' | 'socialOrderFocus'

export const searchConfig: GRID_FORM_CONFIG_T<{ search: string }> = [
  [
    {
      id: 1,
      controllerName: 'search',
      RenderElement: SearchInput,
      renderProps: () => ({
        placeholder: 'Поиск...',
        fullWidth: true,
        inputProps: { maxLength: 255 },
      }),
    },
  ],
]

export const focusFiltration: GRID_FORM_CONFIG_T<{ focus: string[] }> = [
  [
    {
      id: 2,
      controllerName: 'focus',
      RenderElement: FocusCheckboxGroup,
      renderProps: () => ({
        options: SOCIAL_ORDER_FOCUS_OPTIONS,
      }),
    },
  ],
]

const formConfigs: Record<FiltrationBlockName, GRID_FORM_CONFIG_T<unknown>> = {
  search: searchConfig as GRID_FORM_CONFIG_T<unknown>,
  socialOrderFocus: focusFiltration as GRID_FORM_CONFIG_T<unknown>,
}

export const getFormConfig = (blockName: FiltrationBlockName) => formConfigs[blockName]
